/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationAssignResVo
 */
export interface AdminStockAdjustLocationAssignResVo {
    /**
     * 目标货位号
     * @type {string}
     * @memberof AdminStockAdjustLocationAssignResVo
     */
    locationNo?: string;
    /**
     * 已成功指定的箱唛编号
     * @type {Array<string>}
     * @memberof AdminStockAdjustLocationAssignResVo
     */
    assignedMarkNos?: Array<string>;
    /**
     * 成功指定的箱数量
     * @type {number}
     * @memberof AdminStockAdjustLocationAssignResVo
     */
    assignedBoxCount?: number;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationAssignResVo interface.
 */
export function instanceOfAdminStockAdjustLocationAssignResVo(value: object): value is AdminStockAdjustLocationAssignResVo {
    return true;
}

export function AdminStockAdjustLocationAssignResVoFromJSON(json: any): AdminStockAdjustLocationAssignResVo {
    return AdminStockAdjustLocationAssignResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationAssignResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationAssignResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'assignedMarkNos': json['assignedMarkNos'] == null ? undefined : json['assignedMarkNos'],
        'assignedBoxCount': json['assignedBoxCount'] == null ? undefined : json['assignedBoxCount'],
    };
}

export function AdminStockAdjustLocationAssignResVoToJSON(json: any): AdminStockAdjustLocationAssignResVo {
    return AdminStockAdjustLocationAssignResVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationAssignResVoToJSONTyped(value?: AdminStockAdjustLocationAssignResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationNo': value['locationNo'],
        'assignedMarkNos': value['assignedMarkNos'],
        'assignedBoxCount': value['assignedBoxCount'],
    };
}

